import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./style.scss";
import { FraudEntryType } from "shared/types/types";
import FraudStepInput from "./components/FraudStepInput/FraudStepInput";
import FraudStepResult from "./components/FraudStepResult/FraudStepResult";
import FraudStepTypeSelect from "./components/FraudStepTypeSelect/FraudStepTypeSelect";


export default function FraudWizardPage() {
  const [step, setStep] = useState(1);
  const [entryType, setEntryType] = useState<FraudEntryType>(null);
  const [entryValue, setEntryValue] = useState<string | File | null>(null);
  const [result, setResult] = useState<any | null>(null);
  const [error, setError] = useState<string | null>(null);

  const goNext = () => setStep((s) => s + 1);
  const goPrev = () => setStep((s) => s - 1);

  const reset = () => {
    setStep(1);
    setEntryType(null);
    setEntryValue(null);
    setResult(null);
    setError(null);
  };

  return (
    <div className="wizard-container-fraud">
      <AnimatePresence mode="wait">
        {step === 1 && (
          <motion.div
            key="step1"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.4 }}
          >
            <FraudStepTypeSelect
              entryType={entryType}
              setEntryType={setEntryType}
              onNext={goNext}
            />
          </motion.div>
        )}

        {step === 2 && entryType && (
          <motion.div
            key="step2"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.4 }}
          >
            <FraudStepInput
              entryType={entryType}
              onBack={goPrev}
              onNext={(val, result, err) => {
                setEntryValue(val);
                setResult(result);
                setError(err);
                setStep(3);
              }}
            />
          </motion.div>
        )}

        {step === 3 && (
          <motion.div
            key="step3"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.4 }}
          >
            <FraudStepResult
              result={result}
              error={error}
              onRestart={reset}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
